import React from 'react';
import Firebase from 'firebase';
import M from 'react-materialize';

class Settings extends React.Component {

	
	render() {
		return (
		  <div></div>
		);
	}
}
 export default Settings;


// WEBPACK FOOTER //
// ./src/Settings.js